import Layout from '@/upgrade-page/layout';
import routerDashboard from './router-dashboard';
import routerStatic from './router-static';
import routerMoney from './router-money';
import routerUser from './router-user';
import routerWrap from './router-wrap';
import routerActivity from './router-activity';
import noticeRouters from './router-notice';
import newUserRouters from './router-new-user';

const routerNew = [
  /**
   * meta配置項：
   * keepAlive: <Boolean> 緩存頁面 <keep-alive></keep-alive>
   * hideNav: <Boolean> 隱藏左側導航
   * hideFooter: <Boolean> 隱藏底部Footer（如果顯示左側導航，則自動隱藏底部footer）
   * showBack: <Boolean> 顯示返回按鈕 $router.go(-1)
   * darkMode: <Boolean> 深色模式（极速约单）
   * needLogin: <Boolean> 需要登录后才能进入的页面
   * pageWidth: <Number|String> 页面宽度（默认1100，自定义宽度可以覆盖默认，Number会自动补齐px，String为了方便设置100%）
   * needMedia: <Boolean> 需要做移動端適配
   */
  {
    path: '/',
    component: Layout,
    children: [
      ...routerDashboard,
      ...routerStatic,
      ...routerMoney,
      ...routerUser,
      ...routerActivity,
      ...noticeRouters,
      // 语音房
      {
        path: '/voice-room/:roomUid',
        name: 'VoiceRoom',
        component: () => import('@/upgrade-page/views/voice-room/index'),
        meta: {
          hideFooter: true,
          metaWidth: '100%',
          needLogin: true,
          pageWidth: '100%',
          darkMode: true
        }
      },
      //游戏房
      {
        path: '/game-room/:roomId/:gameId',
        name: 'GameRoom',
        component: () => import('@/upgrade-page/views/game-room/index'),
        meta: {
          hideFooter: true,
          metaWidth: '100%',
          needLogin: true,
          pageWidth: '100%',
          darkMode: true
        }
      },
      // 首頁
      {
        path: '/',
        name: 'homepage',
        component: () => import('@/upgrade-page/views/home'),
        meta: {
          keepAlive: true,
          needMedia: true
        }
      },
      // IM
      {
        path: '/chat/:from/:to?',
        name: 'Chat',
        component: () => import('@/upgrade-page/views/chat/index'),
        meta: {
          hideNav: true,
          hideFooter: true,
          metaWidth: '100%',
          needLogin: true
        }
      },
      // 極速約單
      {
        path: '/quick-order',
        name: 'QuickOrder',
        component: () => import('@/upgrade-page/views/quick-order'),
        meta: {
          darkMode: true,
          needMedia: true,
          needLogin: true
        }
      },
      // 动态广场
      {
        path: '/feed-list',
        name: 'FeedList',
        component: () => import('@/upgrade-page/views/feed-list'),
        meta: {}
      },
      // 熱門推薦
      {
        path: '/recommend-list',
        name: 'Recommendist',
        component: () => import('@/upgrade-page/views/feed-list/recommend'),
        meta: {
          pageWidth: 980
        }
      },
      // 個人詳情頁
      {
        path: '/player-detail/:uuid(\\d+|ref\\w+)',
        name: 'playerDetail',
        component: () => import('@/upgrade-page/views/master/index'),
        meta: {
          needMedia: true
        }
      },
      // 個人詳情頁
      {
        path: '/player-detail/:aliasName',
        name: 'AliasNamePlayerDetail',
        component: () => import('@/upgrade-page/views/master/index'),
        meta: {
          needMedia: true
        }
      },
      // mobile技能詳情頁
      {
        path: '/skill-mobile/:skillId(\\d+)/:uuid(\\d+)?',
        name: 'skillDetail',
        component: () =>
          import('@/upgrade-page/views/player-detail/skill-mobile'),
        meta: {
          needMedia: true
        }
      },
      // 技能詳情（技能下的陪玩列表）
      {
        path: '/player-list/:skillId(\\d+)',
        name: 'playerList',
        component: () => import('@/upgrade-page/views/player-list/index'),
        meta: {
          keepAlive: true,
          needMedia: true
        }
      },
      // 搜索結果
      {
        path: '/search-list/:keyword',
        name: 'searchList',
        component: () => import('@/upgrade-page/views/search-list/index'),
        meta: {
          hideFooter: true,
          keepAlive: true,
          needMedia: true
        }
      },
      // 全部技能（全部遊戲列表）
      {
        path: '/skill-list',
        name: 'skillList',
        component: () => import('@/upgrade-page/views/skill-list/index'),
        meta: {
          keepAlive: true,
          needMedia: true
        }
      },
      // 下单列表
      {
        path: '/order-list',
        name: 'OrderList',
        component: () => import('@/upgrade-page/views/order/index'),
        meta: {
          needLogin: true
        }
      },
      // 確認訂單
      {
        path: '/order/check/:skill/:count',
        name: 'OrderCheck',
        component: () => import('@/upgrade-page/views/order/confirm-order'),
        meta: {
          hideNav: true,
          needMedia: true
        }
      },
      // 申請入駐介紹頁
      {
        path: '/before-settled',
        name: 'BeforeSettled',
        component: () =>
          import('@/upgrade-page/views/settled-in/before-settled'),
        meta: {
          hideNav: true,
          pageWidth: '100%'
        }
      },
      /** 申請入駐 */
      {
        path: '/settled',
        name: 'SettledIn',
        component: () => import('@/upgrade-page/views/settled-in/step-2'),
        meta: {
          hideNav: true,
          needLogin: true
        }
      },
      // 入驻流程
      {
        path: '/first-settle',
        name: 'FirstSettle',
        component: () => import('@/upgrade-page/views/settled-in'),
        meta: {
          hideNav: true,
          needLogin: true,
          pageWidth: 980
        }
      },
      /** LOL抽奖活动 */
      {
        path: '/luck-draw',
        name: 'LuckDraw',
        component: () => import('@/activities/luck-draw/index'),
        meta: {
          hideNav: true,
          pageWidth: '100%',
          needMedia: true
        }
      },
      // 语音房管理员管理
      {
        path: '/administrator-management',
        name: 'AdministratorManagement',
        component: () => import('@/upgrade-page/views/administrator-management/index'),
        meta: {
          hideNav: true,
          pageWidth: '100%',
          needMedia: true
        }
      },
    ]
  },
  ...routerWrap,
  ...newUserRouters,
  // 重定向到陪玩师详情，使用别名查找陪玩师
  {
    path: '/:pathMatch(.*)*',
    redirect: to => {
      console.log(to);
      return {  name: 'AliasNamePlayerDetail',params: {aliasName:to.path.slice(1)}  };
    }
  }
];

const len = routerNew.length;
for (let i = 0; i < len; i++) {
  const item = routerNew[i];
  if (item.path === '/') {
    // 仪表板页面统一处理，不显示左侧导航
    const dashItem = item.children.find(item => item.path === '/player');
    if (dashItem) {
      dashItem.children.forEach(item => {
        if (!item.meta) item.meta = {};
        item.meta.hideNav = true;
        item.meta.hideFooter = true;
        item.meta.needLogin = true;
      });
    }
    break;
  }
}

export default routerNew;
